module.exports = require("figures");


//////////////////
// WEBPACK FOOTER
// external "figures"
// module id = 17
// module chunks = 0